import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import { Button, useRecordContext } from "react-admin";
import { API_URL, APP_URL } from "@/config/api";

/**
 * Button to impersonate a user via better-auth's admin plugin.
 * Navigates directly to a server endpoint that sets the impersonation
 * session cookie and redirects to the app.
 */
export const ImpersonateButton = () => {
	const record = useRecordContext();

	if (!record) return null;

	const handleImpersonate = () => {
		const params = new URLSearchParams({
			userId: String(record.id),
			redirect: APP_URL,
		});
		window.location.href = `${API_URL}/api/auth/impersonate-redirect?${params}`;
	};

	return (
		<Button
			label="Impersonate"
			onClick={handleImpersonate}
			startIcon={<SwitchAccountIcon />}
		/>
	);
};
